var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.49 268.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.49,30.28l0,0Q349.19,148.55,231,266.8l-.27.28a4.7,4.7,0,0,1-6.71.08L117.66,160.73a4.67,4.67,0,0,1,0-6.61l21-21.06a4.68,4.68,0,0,1,6.62,0l77.81,77.86a4.68,4.68,0,0,0,6.64,0L437.36,1.38a4.69,4.69,0,0,1,6.48-.16L467.39,22.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.38,150.5c-6.73-6.77-13.64-13.7-20.32-20.4a4.61,4.61,0,0,1,0-6.51C243.14,83.51,283.54,43.12,323.69,3a4.61,4.61,0,0,1,6.53,0c6.54,6.58,13.47,13.54,20.31,20.4a4.62,4.62,0,0,1,0,6.51L229.9,150.5A4.6,4.6,0,0,1,223.38,150.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,246l-16.58,16.6a10.09,10.09,0,0,1-14.28,0L1.28,159.71a4.37,4.37,0,0,1,.05-6.22l20.92-20.28a4.36,4.36,0,0,1,6.12,0L135,239.83A4.37,4.37,0,0,1,135,246Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.54ea7971cc90c9e4d59a70befa289390.svg";
export { ForwardRef as ReactComponent };